import { Navigation } from '../components/Navigation';
import { About as AboutSection } from '../components/About';
import { Footer } from '../components/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="pt-20">
        <AboutSection />
      </div>
      <Footer />
    </div>
  );
}
